module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "schema-manager"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('SchemaTabs', {
    attrs: {
      "tabs": _vm.tabs,
      "initialTab": _vm.initialTab
    }
  }, [_c('template', {
    slot: "tab-panel-question"
  }, [_c('SchemaQuestion')], 1), _vm._v(" "), _c('template', {
    slot: "tab-panel-masterlist"
  }, [_c('SchemaMasterlist')], 1), _vm._v(" "), _c('template', {
    slot: "tab-panel-purpose"
  }, [_c('SchemaPurpose')], 1), _vm._v(" "), _c('template', {
    slot: "tab-panel-group"
  }, [_c('SchemaGroup')], 1)], 2)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79f2cfe1"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/internal/main/schema_manager.vue
// module id = 1018
// module chunks = 0